export default __webpack_public_path__ + "static/media/Foto4.929117ba.png";